/**
 * Single switch for every app-install surface on the website.
 *
 * There is no PUBLIC app store listing yet (the Android build is in closed
 * testing, iOS not live), so the site must not advertise an app a visitor
 * can't actually install — broken Play/App Store links and a MobileApplication
 * entity for a non-existent app hurt trust + SEO (rule 26).
 *
 * `false` removes, across the whole site:
 *   - AppDeepLink (astrologers/pandits "open in app")
 *   - the /get-app route (redirects home)
 *   - the MobileApplication JSON-LD (layout.tsx)
 *   - the Play/App Store anchors in SAME_AS (schema.ts)
 *
 * At launch: verify both store listings are PUBLIC, flip to `true`, redeploy,
 * and re-crawl (GSC) so the app entity re-enters the graph. NOTE: this is a
 * build-time constant inlined into the bundle, so flipping it needs a web
 * deploy, not just a runtime env change.
 */
export const APP_AVAILABLE = false;
